/// <amd-module name="SuiteCommerce.SizeChart.Common.InstrumentationHelper"/>
define("SuiteCommerce.SizeChart.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.SizeChart.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QueueNameSuffix = '-SizeChart';
    var ExtensionVersion = '1.0.5';
    var ComponentArea = 'SC Size Chart';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                }
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
